export const RouteListTabs = {
  compact: "compact",
  detailed: "detailed",
  stats: "stats",
  defRoutes: "defRoutes",
};
